import React, { useRef } from "react";
import {
  bar2,
  ChevronLeft,
  ChevronRight,
  infoOutlineMini,
  LocationMarkMini,
  loveOutlineMini,
} from "../assets/SvgIcons";
import { Link } from "react-router-dom";

/**
 * @author
 * @function SupplierListing
 **/

const sortOptions = [
  {
    label: "Relevance",
    value: "/rolex/index.htm?man=rolex&pageSize=30&showpage=1&sortorder=0",
    action: "sortOrder: relevance",
    context: "relevance",
  },
  {
    label: "Price: low to high",
    value: "/rolex/index.htm?man=rolex&pageSize=30&showpage=1&sortorder=1",
    action: "sortOrder: price",
    context: "price_asc",
  },
  {
    label: "Price: high to low",
    value: "/rolex/index.htm?man=rolex&pageSize=30&showpage=1&sortorder=11",
    action: "sortOrder: price-desc",
    context: "price_desc",
  },
  {
    label: "Newest",
    value: "/rolex/index.htm?man=rolex&pageSize=30&showpage=1&sortorder=5",
    action: "sortOrder: newest",
    context: "newest",
  },
  {
    label: "Popularity",
    value: "/rolex/index.htm?man=rolex&pageSize=30&showpage=1&sortorder=15",
    action: "sortOrder: user-popularity",
    context: "popularity",
  },
];

const watches = [
  {
    name: "Dummy Watch 1",
    description: "Dummy Description 1",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Featured",
    additional_info: "Dummy Info 1",
    price: "$100",
    shipping: "$10",
    location: "US",
  },
  {
    name: "Dummy Watch 2",
    description: "Dummy Description 2",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Featured",
    additional_info: "Dummy Info 2",
    price: "$150",
    shipping: "$15",
    location: "US",
  },
  {
    name: "Dummy Watch 3",
    description: "Dummy Description 3",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Featured",
    additional_info: "Dummy Info 3",
    price: "$200",
    shipping: "$20",
    location: "US",
  },
  {
    name: "Dummy Watch 4",
    description: "Dummy Description 4",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Pre Owned",
    additional_info: "Dummy Info 4",
    price: "$250",
    shipping: "$25",
    location: "US",
  },
  {
    name: "Dummy Watch 2",
    description: "Dummy Description 2",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "New",
    additional_info: "Dummy Info 2",
    price: "$150",
    shipping: "$15",
    location: "US",
  },
  {
    name: "Dummy Watch 3",
    description: "Dummy Description 3",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 3",
    price: "$200",
    shipping: "$20",
    location: "US",
  },
  {
    name: "Dummy Watch 4",
    description: "Dummy Description 4",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 4",
    price: "$250",
    shipping: "$25",
    location: "US",
  },
  {
    name: "Dummy Watch 2",
    description: "Dummy Description 2",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 2",
    price: "$150",
    shipping: "$15",
    location: "US",
  },
  {
    name: "Dummy Watch 3",
    description: "Dummy Description 3",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 3",
    price: "$200",
    shipping: "$20",
    location: "US",
  },
  {
    name: "Dummy Watch 4",
    description: "Dummy Description 4",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 4",
    price: "$250",
    shipping: "$25",
    location: "US",
  },
  {
    name: "Dummy Watch 2",
    description: "Dummy Description 2",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 2",
    price: "$150",
    shipping: "$15",
    location: "US",
  },
  {
    name: "Dummy Watch 3",
    description: "Dummy Description 3",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 3",
    price: "$200",
    shipping: "$20",
    location: "US",
  },
  {
    name: "Dummy Watch 4",
    description: "Dummy Description 4",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 4",
    price: "$250",
    shipping: "$25",
    location: "US",
  },
  {
    name: "Dummy Watch 2",
    description: "Dummy Description 2",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 2",
    price: "$150",
    shipping: "$15",
    location: "US",
  },
  {
    name: "Dummy Watch 3",
    description: "Dummy Description 3",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 3",
    price: "$200",
    shipping: "$20",
    location: "US",
  },
  {
    name: "Dummy Watch 4",
    description: "Dummy Description 4",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 4",
    price: "$250",
    shipping: "$25",
    location: "US",
  },
  {
    name: "Dummy Watch 2",
    description: "Dummy Description 2",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 2",
    price: "$150",
    shipping: "$15",
    location: "US",
  },
  {
    name: "Dummy Watch 3",
    description: "Dummy Description 3",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 3",
    price: "$200",
    shipping: "$20",
    location: "US",
  },
  {
    name: "Dummy Watch 4",
    description: "Dummy Description 4",
    link: "/watch?id=watch_id",
    image: [
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
      "https://main.d2qfb7a0oc8xva.amplifyapp.com/static/media/9.13f6f2f51394552b0d2c0a8415beee8b.svg",
    ],
    badge: "Dummy Badge",
    additional_info: "Dummy Info 4",
    price: "$250",
    shipping: "$25",
    location: "US",
  },
];

export const SupplierListing = (props) => {
  return (
    <>
      <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12">
        <div className="my-4 ">
          <ListingPageHeading />
          <ListingControls listingsCount={watches?.length + 91239} />
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 items-start justify-between gap-8 w-full mb-12">
          {watches?.map((watch, index) => (
            <ProductCard key={index} watch={watch} />
          ))}
        </div>

        <Pagination
          currentPage={1}
          totalPages={1707}
          onPageChange={(page) => console.log("Selected Page:", page)}
          pageSize={30}
          onPageSizeChange={(size) => console.log("Selected Page Size:", size)}
        />
      </section>
    </>
  );
};

const ProductCard = ({ watch }) => {
  const scrollRef = useRef(null);
  return (
    <div
      //
      className="bg-[#E4E2DD]  rounded-lg overflow-hidden "
    >
      <div className="relative">
        <div ref={scrollRef} className="flex overflow-x-scroll no-scrollbar">
          {watch?.image?.map((img, index) => {
            return (
              <img
                key={index}
                src={img}
                alt={watch.name}
                className=" object-cover shadow-sm"
              />
            );
          })}
        </div>
        <div className="w-full h-full absolute top-0  ">
          {/* BADGE AND LOVE REACT */}
          <div className="w-full flex justify-between items-center px-4 py-3">
            {watch.badge && (
              <span className="shadow inline-block bg-white text-black text-xs font-semibold px-2 py-1 rounded mb-2">
                {watch.badge}
              </span>
            )}
            <button className="shadow bg-white rounded-full p-1">
              {loveOutlineMini}
            </button>{" "}
          </div>

          {/* IMG TOGGLE */}
          {/* <div className="w-full flex justify-between items-center px-1 py-3  absolute top-1/2 ">
            <button
              onClick={() => {
                scrollRef.current.scrollBy({
                  left:
                    -1 *
                    (scrollRef.current ? scrollRef.current.clientWidth : 0),
                  behavior: "smooth",
                });
              }}
              className="p-1 bg-[rgba(255,255,255,0.79)]  rounded-full flex items-center"
              aria-label="Previous page"
            >
              {ChevronLeft}
            </button>

            <button
              onClick={() => {
                scrollRef.current.scrollBy({
                  left:
                    1 * (scrollRef.current ? scrollRef.current.clientWidth : 0),
                  behavior: "smooth",
                });
              }}
              className="p-1 bg-[rgba(255,255,255,0.79)]  rounded-full flex items-center"
              aria-label="Next page"
            >
              {ChevronRight}
            </button>
          </div> */}
        </div>
      </div>
      <Link to={watch?.link}>
        <div className="p-4">
          <h2 className="text-[14px] text-[#5596B0] font-bold mb-1">
            {watch.name}
          </h2>
          <p className="text-gray-600 mb-2 text-[14px]">
            {watch.description?.slice(0, 34)}..
          </p>
          {/* <a
          href={watch.link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-blue-500 text-white text-center py-2 px-4 rounded hover:bg-blue-600 transition-colors duration-200"
        >
          View Listing
        </a> */}

          <div className="flex justify-between items-center gap-4 mt-2 text-[#5596B0]">
            <div>
              <strong className="text-[14px]">Price {watch?.price}</strong>
              {/* <p className="text-[13px] text-gray-400">
                + {watch?.shipping} for shipping
              </p> */}
            </div>
            <div>
              {LocationMarkMini}
              <p className="text-[14px]">{watch?.location}</p>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};
const ListingPageHeading = ({}) => {
  return (
    <div className="flex items-center justify-between text-base py-4 my-4 border-b">
      <h2 className="lg:text-4xl md:text-3xl sm:text-2xl font-semibold ">
        Luxury Time Global
      </h2>

      <img
        className="h-[60px] w-[120px]"
        src="https://cdn2.chrono24.com/images/haendlerlogos/ek_lux_global-hj8tgc9ubo0ahuq9a24rco02-Large.png"
        alt=""
      />
    </div>
  );
};
const ListingControls = ({ listingsCount, onSortChange }) => {
  return (
    <div className="flex items-center justify-between text-base my-8">
      <div className="flex gap-2 items-center">
        <strong>{listingsCount} listings</strong> including promoted listings
        <button
          type="button"
          className="relative p-0"
          data-content='Information about the ranking of search results<a class="m-l-1" href="/info/ranking.htm">Learn more</a>'
          data-append-to-body="true"
          aria-label="Learn more about: Ranking"
        >
          {infoOutlineMini}
        </button>
      </div>

      <div className="text-right">
        <label className="flex items-center">
          <span className="mr-2">Sort by:</span>
          <select
            className="border rounded px-4 py-2 bg-transparent text-base"
            onChange={(e) => onSortChange(e.target.value)}
          >
            {sortOptions.map((option) => (
              <option
                key={option.value}
                value={option.value}
                data-tce-action={option.action}
                data-ga4-event-context={option.context}
              >
                {option.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  );
};
const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  pageSize,
  onPageSizeChange,
}) => {
  const pageSizes = [30, 60, 120];
  const maxPageLinks = 5; // number of page links to show before ellipsis
  const startPage = Math.max(currentPage - Math.floor(maxPageLinks / 2), 1);
  const endPage = Math.min(startPage + maxPageLinks - 1, totalPages);

  return (
    <nav className="flex items-center justify-between text-sm">
      {/* Page Size Selector */}
      <div className="lg:flex md:flex sm:hidden  gap-2 items-center">
        <div className="flex gap-2 items-center">
          {pageSizes.map((size) => (
            <div key={size}>
              {size === pageSize ? (
                <span className="px-3 h-[32px] bg-primary text-white flex items-center rounded">
                  {size}
                </span>
              ) : (
                <button
                  onClick={() => onPageSizeChange(size)}
                  className="px-3 h-[32px] bg-primarylight  flex items-center  rounded"
                >
                  {size}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Pagination Links */}
      <div className="lg:mx-0 md:mx-0 sm:mx-auto flex gap-2 justify-center items-center">
        {/* Previous Button */}
        <div>
          {currentPage > 1 ? (
            <button
              onClick={() => onPageChange(currentPage - 1)}
              className="px-3 h-[32px]  rounded flex items-center"
              aria-label="Previous page"
            >
              {ChevronLeft}
            </button>
          ) : (
            <span className="px-3 h-[32px]  rounded cursor-not-allowed flex items-center">
              {ChevronLeft}
            </span>
          )}
        </div>

        {/* Page Numbers */}
        {[...Array(endPage - startPage + 1)].map((_, idx) => {
          const page = startPage + idx;
          return (
            <div key={page} className="flex items-center">
              {page === currentPage ? (
                <span className="px-3 h-[32px] bg-primary text-white  flex items-center  rounded">
                  {page}
                </span>
              ) : (
                <button
                  onClick={() => onPageChange(page)}
                  className="px-3 h-[32px] bg-primarylight  flex items-center  rounded"
                  aria-label={`Page ${page}`}
                >
                  {page}
                </button>
              )}
            </div>
          );
        })}

        {/* Next Button */}
        <div>
          {currentPage < totalPages ? (
            <button
              onClick={() => onPageChange(currentPage + 1)}
              className="px-3 h-[32px]  rounded flex items-center"
              aria-label="Next page"
            >
              {ChevronRight}
            </button>
          ) : (
            <span className="px-3 h-[32px] bg-gray-300 rounded cursor-not-allowed flex items-center">
              {ChevronRight}
            </span>
          )}
        </div>
      </div>
    </nav>
  );
};
